import Fallback from './DashboardTemplatesEdit.fallback';
import { routeEntry } from '../route-utils';

export default routeEntry({
  fallback: <Fallback />,
  component: () => import('./DashboardTemplatesEdit.page'),
});
